<h2 mat-dialog-title class="dialog-header">
  <span>Create Job</span>
  <button mat-icon-button aria-label="Close" (click)="activeModal.close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content mat-typography schedule-dialog-content">
  <div class="form-grid two-columns schedule-form-grid">
    <mat-form-field appearance="outline">
      <mat-label>Job Name</mat-label>
      <mat-select [(ngModel)]="jobParamenter.jobName">
        <mat-option *ngFor="let cronName of cronNames" [value]="cronName">{{ cronName }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Job Schedule Time (UTC)</mat-label>
      <input matInput type="datetime-local" [(ngModel)]="jobParamenter.jobScheduleTime">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Cron Expression</mat-label>
      <input matInput [(ngModel)]="jobParamenter.cronExpression">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Ejemplo cron</mat-label>
      <mat-select #cronExpressionExample (selectionChange)="jobParamenter.cronExpression = cronExpressionExample.value">
        <mat-option value="0 0 7 ? * *">Todos los dias 7 UTC horas</mat-option>
        <mat-option value="1 * * ? * * *">Cada minuto</mat-option>
        <mat-option value="0/20 * * ? * * *">Cada 20 minuto</mat-option>
        <mat-option value="0/10 * * ? * * *">Cada 10 segundos</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <section class="cron-help-card" aria-label="Guia de expresiones cron">
    <div class="cron-help-header">
      <h3>Guia de expresion cron</h3>
      <p>Formato Quartz con segundos al inicio y ano opcional al final.</p>
    </div>

    <div class="cron-help-grid">
      <div class="cron-help-row">
        <span class="cron-help-label">Seconds</span>
        <code class="cron-help-value">0-59 , - * /</code>
      </div>
      <div class="cron-help-row">
        <span class="cron-help-label">Minutes</span>
        <code class="cron-help-value">0-59 , - * /</code>
      </div>
      <div class="cron-help-row">
        <span class="cron-help-label">Hours</span>
        <code class="cron-help-value">0-23 , - * /</code>
      </div>
      <div class="cron-help-row">
        <span class="cron-help-label">Day of month</span>
        <code class="cron-help-value">1-31 , - * ? / L W</code>
      </div>
      <div class="cron-help-row">
        <span class="cron-help-label">Month</span>
        <code class="cron-help-value">1-12 or JAN-DEC , - * /</code>
      </div>
      <div class="cron-help-row">
        <span class="cron-help-label">Day of week</span>
        <code class="cron-help-value">1-7 or SUN-SAT , - * ? / L #</code>
      </div>
      <div class="cron-help-row">
        <span class="cron-help-label">Year</span>
        <code class="cron-help-value">empty or 1970-2099 , - * /</code>
      </div>
    </div>

    <div class="cron-help-examples">
      <div class="cron-help-example">
        <code>0 0 12 * * ?</code>
        <span>Fire at 12pm every day</span>
      </div>
      <div class="cron-help-example">
        <code>0 15 10 ? * *</code>
        <span>Fire at 10:15am every day</span>
      </div>
      <div class="cron-help-example">
        <code>0 0/5 14 * * ?</code>
        <span>Fire every 5 minutes from 2pm to 2:55pm</span>
      </div>
      <div class="cron-help-example">
        <code>0 15 10 ? * MON-FRI</code>
        <span>Fire at 10:15am Monday to Friday</span>
      </div>
    </div>
  </section>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <div class="dialog-actions-wrap">
    <button mat-raised-button color="primary" (click)="confirm()">Guardar</button>
    <button mat-stroked-button color="warn" (click)="deleteManagerJob()">Eliminar</button>
  </div>
  <div class="dialog-actions-wrap">
    <button mat-button (click)="unscheduleJob()">Unschedule</button>
    <button mat-button (click)="pauseJob()">Pause</button>
    <button mat-button (click)="resumeJob()">Resume</button>
    <button mat-button (click)="checkJobNameJob()">Check Name</button>
    <button mat-button (click)="isJobRunningJob()">Is Running</button>
    <button mat-button (click)="jobStateJob()">State</button>
    <button mat-button (click)="stopJob()">Stop</button>
    <button mat-button (click)="startJob()">Start</button>
  </div>
</mat-dialog-actions>
